// ActionButton.js
import React from 'react';
import { PiShareFatFill } from "react-icons/pi";
import './ActionButton.scss';

const ActionButton = () => {
  return (
    <button className="action-button">
      Send
      <PiShareFatFill className="icon" />
    </button>
  );
};

export default ActionButton;
